import React from 'react';

const RequestTabContainer = ({ show, component, ...rest }) => {
  if (!show) return null;
  const TabComponent = component;
  return <TabComponent {...rest} />;
};

export default RequestTabContainer;



// WEBPACK FOOTER //
// ./src/containers/RequestTabContainer.js